export default "<select class=\"filter-locations\" multiple=\"multiple\"></select>\n"